import { render, staticRenderFns } from "./AddEditClientDialog.vue?vue&type=template&id=3a7aced7&scoped=true&"
import script from "./AddEditClientDialog.vue?vue&type=script&lang=js&"
export * from "./AddEditClientDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddEditClientDialog.vue?vue&type=style&index=0&id=3a7aced7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7aced7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a7aced7')) {
      api.createRecord('3a7aced7', component.options)
    } else {
      api.reload('3a7aced7', component.options)
    }
    module.hot.accept("./AddEditClientDialog.vue?vue&type=template&id=3a7aced7&scoped=true&", function () {
      api.rerender('3a7aced7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/clients/AddEditClientDialog.vue"
export default component.exports